// API Client
import { post } from "../CarbonClient";

// Types
import {
  InspectDataType,
  InspectTreeNavigationType,
  InspectTreeNavigationRequestType,
  InspectBuildingProjectConstructionRequestType,
  InspectBuildingProjectEpdRequestType,
  InspectBuildingProjectMaterialRequestType,
  InspectBuildingProjectTypeRequestType,
  InspectBuildingProjectIdType,
} from "@/features/Inspect";

// API Path
const path = "api/inspect/";

export const getInspectBuildingProjectTree = async ({
  data,
  buildingProjectId,
}: {
  data: InspectTreeNavigationRequestType;
  buildingProjectId: InspectBuildingProjectIdType;
}): Promise<InspectTreeNavigationType> => post(`${path}buildingProject/${buildingProjectId}`, data);

export const inspectBuildingProjectType = async ({
  data,
  buildingProjectId,
}: {
  data: InspectBuildingProjectTypeRequestType;
  buildingProjectId: InspectBuildingProjectIdType;
}): Promise<InspectDataType> => post(`${path}buildingProject/${buildingProjectId}/type`, data);

export const inspectBuildingProjectConstruction = async ({
  data,
  buildingProjectId,
}: {
  data: InspectBuildingProjectConstructionRequestType;
  buildingProjectId: InspectBuildingProjectIdType;
}): Promise<InspectDataType> => post(`${path}buildingProject/${buildingProjectId}/construction`, data);

export const inspectBuildingProjectMaterial = async ({
  data,
  buildingProjectId,
}: {
  data: InspectBuildingProjectMaterialRequestType;
  buildingProjectId: InspectBuildingProjectIdType;
}): Promise<InspectDataType> => post(`${path}buildingProject/${buildingProjectId}/material`, data);

export const inspectBuildingProjectEpd = async ({
  data,
  buildingProjectId,
}: {
  data: InspectBuildingProjectEpdRequestType;
  buildingProjectId: InspectBuildingProjectIdType;
}): Promise<InspectDataType> => post(`${path}buildingProject/${buildingProjectId}/epd`, data);
